(function () {
  function initMusicPlayer(context = document) {
    const buttons = context.querySelectorAll('#playMusicButton');
    const player = document.getElementById('musicPlayer');
    const iframe = player?.querySelector('iframe');

    if (!player || !iframe) return;

    buttons.forEach((button) => {
      if (button.dataset.musicBound === 'true') return;
      button.dataset.musicBound = 'true';

      button.addEventListener('click', function () {
        player.style.visibility = 'visible';
        player.style.pointerEvents = 'auto';

        if (!iframe.src) {
          iframe.src = iframe.dataset.src;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMusicPlayer(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initMusicPlayer(event.target);
  });
})();
